import type { Customer } from '@gh/common/models'
import { type Subscription } from '@gh/common/models'
import { firestoreTimestampToDate } from '../utils'
import { usePaymentMethodStore } from '@/stores/paymentMethod'
import { storeToRefs } from 'pinia'

/**
 * @deprecated use subscriptionActiveForCustomer instead
 */
export function isSubscriptionActive(
  customer: Customer | undefined | null,
  subscription: Subscription | null,
) {
  if (subscription) {
    return (
      subscription.type === 'subscription' &&
      subscription.subscriptionInfo?.status === 'active' &&
      subscription.subscriptionInfo?.lastPeriodEnd &&
      firestoreTimestampToDate(subscription.subscriptionInfo?.lastPeriodEnd) > new Date()
    )
  }
  if (customer?.signupPaymentInfo) {
    return (
      customer.signupPaymentInfo?.mode === 'subscription' &&
      customer.signupPaymentInfo?.endDate &&
      firestoreTimestampToDate(customer.signupPaymentInfo?.endDate) > new Date()
    )
  }
  return false
}

export function isPaymentActive(
  customer: Customer | undefined | null,
  subscription: Subscription | null,
) {
  if (subscription) {
    return (
      subscription.type === 'payment' &&
      subscription.oneTimeInfo &&
      subscription.oneTimeInfo?.status === 'active'
    )
  }
  if (customer?.signupPaymentInfo) {
    return (
      customer.signupPaymentInfo?.mode === 'payment' &&
      customer.signupPaymentInfo?.endDate &&
      customer.signupPaymentInfo?.endDate > new Date()
    )
  }
  return false
}

export const useCurrentUserSubscriptionActive = () => {
  const paymentMethodStore = usePaymentMethodStore()
  const { isLoading, subscriptionActive } = storeToRefs(paymentMethodStore)

  return {
    isSubscriptionActive: subscriptionActive,
    isLoading: isLoading,
  }
}
